import { SVGProps } from 'react';
import * as React from 'react';

export const StationIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg {...props} height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000">
    <path d="M160-720v-80h640v80H160Zm0 560v-240h-40v-80l40-200h640l40 200v80h-40v240h-80v-240H560v240H160Zm80-80h240v-160H240v160Zm-38-240h556-556Zm0 0h556l-24-120H226l-24 120Z" />
  </svg>
);
